import $ from 'jquery';
import BaseController from './BaseController';
import {submitErrorMessage} from "@ppcp/utils";

/**
 * Product Controller
 *
 * Handles WooCommerce product page payment flow orchestration.
 * Works with any payment gateway (PayPal, Google Pay, etc.)
 */
class ProductController extends BaseController {

    constructor(product, props) {
        super(props);
        this.product = product;
    }

    initialize() {
        this.actions.addAction('found_variation', this.onFoundVariation.bind(this));
        this.actions.addAction('reset_variation', this.onResetVariation.bind(this));
        this.setMaxWidth();
        super.initialize();
    }

    onPaymentElementReady() {
        super.onPaymentElementReady();
        if (this.product.isVariableProduct()) {
            if (!this.product.isVariationSelected() || !this.product?.variation?.is_in_stock) {
                this.disablePaymentElement(true);
            } else {
                this.enablePaymentElement();
            }
        }
    }

    needsShipping() {
        if (this.cart.isEmpty()) {
            return this.product.needsShipping();
        }
        return this.cart.needsShipping();
    }

    getElementContainer() {
        const containerClass = `wc-${this.id}-product-button-container`;
        const container = document.querySelectorAll(`.${containerClass}`);
        if (container && container.length > 0) {
            return container;
        }
        return document.getElementById(containerClass);
    }

    /**
     * Set maximum width for payment element to match add to cart button width
     */
    setMaxWidth() {
        if (this.settings?.product?.button_width == 'add_to_cart') {
            this.buttonWidth = $('form.cart div.quantity').outerWidth(true) + $('.single_add_to_cart_button').outerWidth();
            var marginLeft = $('.single_add_to_cart_button').css('marginLeft');
            if (marginLeft) {
                this.buttonWidth += parseInt(marginLeft.replace('px', ''));
            }
            $(this.container).css('max-width', this.buttonWidth + 'px');
        }
    }

    submitError(error) {
        this.hideProcessing();
        submitErrorMessage(error, 'div.woocommerce-notices-wrapper');
    }

    /**
     * Add product to cart before creating order
     */
    addToCart() {
        return this.cart.addToCart({
            payment_method: this.id,
            product_id: this.product.getId(),
            variation_id: this.product.getVariationId(),
            qty: this.product.getQuantity(),
            variation: this.product.getVariationData(),
            needs_setup_token: this.settings.needsSetupToken
        }).then(response => {
            if (response.code) {
                this.currentError = response;
            } else {
                this.updateGatewaySettings(response.payment_methods);
                return response.order_id;
            }
        }).catch(err => {
            this.currentError = err;
            return this.submitError(err);
        })
    }

    createOrder() {
        return this.addToCart();
    }

    createVaultSetupToken(data = {}) {
        return this.addToCart().then(() => {
            return super.createVaultSetupToken(data);
        });
    }

    handlePaymentToken(response) {
        super.handlePaymentToken(response);
        this.submit();
    }

    /**
     * Handle variation change event
     * @param {boolean} hasChanged - Whether the variation attributes changed
     * @param {Object} product - Product data
     */
    onFoundVariation(hasChanged, product) {
        if (hasChanged) {
            this.destroyPaymentElement();
            this.createPaymentElement();
        } else {
            if (!product.variation.is_in_stock) {
                this.disablePaymentElement(true);
            } else {
                this.enablePaymentElement();
            }
        }
    }

    /**
     * Handle variation reset event
     */
    onResetVariation() {
        this.disablePaymentElement(true);
    }
}

export {ProductController};
export default ProductController;